function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import { action } from 'mobx';
import { maybeCall } from 'sdc-utilities';
import { async } from '../AsyncHelper';
import * as store from '../StoreHelper';

import { entryMappers } from 'sdc-data-models';

export var Deleting = function Deleting(superclass) {
  var _desc, _value, _class, _descriptor;

  return _class = function (_superclass) {
    _inherits(_class, _superclass);

    function _class() {
      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _superclass.call.apply(_superclass, [this].concat(args))), _this), _this.afterRemove = null, _this.deleteToEntry = entryMappers.deleteToEntry, _this.remove = function (entry) {
        return function (event) {
          event.preventDefault();
          event.stopPropagation();
          async(_this.api.remove(entry)).then(_this.removeEntry);
        };
      }, _initDefineProp(_this, 'removeEntry', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    return _class;
  }(superclass), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'removeEntry', [action], {
    enumerable: true,
    initializer: function initializer() {
      var _this2 = this;

      return function (payload) {
        maybeCall(_this2.clearSelected)();
        var deleted = _this2.deleteToEntry(payload);
        _this2.dataList = store.remove(_this2.dataList)(deleted);

        maybeCall(_this2.afterUpdate)(deleted);
        maybeCall(_this2.afterRemove)(deleted);
        maybeCall(_this2.publishEvent)(deleted, 'deleted');
      };
    }
  })), _class;
};